import React from "react";
import {XFormBase} from "@michalrakus/x-react-web-lib/XFormBase";
import {XUtils} from "@michalrakus/x-react-web-lib/XUtils";

export interface XFormWidthProps {
    form: XFormBase;
    width: string; // e.g. 83rem - max sirka pre formular na ktoru obmedzi vyuziva sa na zuzenie XInputTextarea s width=100% (aby XInputTextarea nebol na cely display)
    children: JSX.Element | JSX.Element[];
}

// obmedzi sirku formulara na "width" (aby nezaberal celu sirku stranky) a zaroven vycentruje
export const XFormWidth = (props: XFormWidthProps) => {
    // na centrovanie nepouzivame flex, lebo flex meni sirku formulara (shrinkuje, treba zapnut grow aby nemenil)
    // marginLeft: 'auto', marginRight: 'auto' sposobi centrovanie
    let style: React.CSSProperties = {marginLeft: 'auto', marginRight: 'auto'};
    const width: string = `min(100vw - ${XUtils.isMobile() ? 1.2 : 2.2}rem, ${props.width})`; // ak je sirka display-a mensia ako zadana sirka (napr. pri mobile) tak sa pouzije sirka display-a (100vw - 1rem)
                                                                    // a vdaka tomu sa zapne scrollovanie v TabView (cez atribut scrollable)
                                                                    // hodilo by sa tu zadat min-content/fit-content ale tieto intrinsic values sa nedaju pouzit vo funkciach ako min/calc
    //if (props.form.isInDialog()) {
        // problem nam robi zobrazenie formu v dialogu, dialog shrinkuje formular, tak pre jednoduchost pouzijeme namiesto maxWidth surovy width
        // (surovy width zas znemozni zuzenie formulara pri "mobile" rozliseni)
        // toto je taky trosku docasny workaround, idealne by bolo nejako pomenit dialog aby sme mohli pouzit maxWidth
    //    style = {...style, width: width}
    //}
    //else {
        // 14.5.2025 - zmenil som maxWidth na width, lebo ked je menej tab-iek (streetwork, spec porad) tak v dialogu nam skace sirka celeho dialogu pri klikani na tab-ky
        // problem na mobile (testovane v browseri) som nezaznamenal
        //style = {...style, maxWidth: width};
        style = {...style, width: width};
    //}

    return (
        <div style={style}>
            {props.children}
        </div>
    );
}
